export const getTarget = (link) => {
  const isAnchorLink = link?.startsWith('#');
  const isHomeDepotLink = link?.includes('homedepot.com');
  return (isAnchorLink || isHomeDepotLink) ? '_self' : '_blank';
};